import type { FlattenSimpleInterpolation } from 'styled-components';
import { css } from 'styled-components';
import type { CustomTheme } from '../../../@types/theme';

export const AudiCopy1WithHoverStyle = (theme: CustomTheme): FlattenSimpleInterpolation => css`
  font-family: ${theme.typography.fontFamily};
  font-size: ${theme.type === 'legacy' ? theme.typography.fontSize : theme.typography.fontSizeM};
  font-stretch: ${theme.typography.fontStretch};
  line-height: ${theme.typography.lineHeight};

  &:hover {
    color: var(${theme.colors.colorHover});
  }
`;

export const timeS = '120ms';
export const timeM = '180ms';
export const timeL = '240ms';
export const timeXL = '420ms';
export const timeXXL = '660ms';
export const timeHeaderTransitionDelay = '300ms'; // time m + s

export const generateMobileMenuMaxHeightCss = (showDealerSearch: boolean = false): string => {
  if (typeof window !== 'undefined' && window.innerHeight) {
    if (showDealerSearch) {
      return `calc(${window.innerHeight}px + 450px)`;
    }
    return `calc(${window.innerHeight}px - var(--one-header-height))`;
  }
  return 'calc(100vh - var(--one-header-height))';
};
